"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFormsList = fetchFormsList;
exports.fetchForm = fetchForm;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var BASE_URL = '/forms/v2';

function fetchFormsList() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var searchTerm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var portalId = _hubspot.default.get();

  return _apiClient.default.get(BASE_URL + "/dashboard/items", {
    query: {
      portalId: portalId,
      limit: limit,
      offset: offset,
      name: searchTerm,
      formTypes: ['CAPTURED', 'HUBSPOT', 'BLOG_COMMENT']
    }
  });
}

function fetchForm(guid) {
  var portalId = _hubspot.default.get();

  return _apiClient.default.get(BASE_URL + "/forms-drafts/" + guid, {
    portalId: portalId
  });
}